import {Schema, String, minLength} from 'effect/Schema';

export const CurrencySign = String.pipe(minLength(1)) as unknown as Schema<CurrencySign>;
export type CurrencySign = import('../../src/Currency/CurrencySign').CurrencySign;
